import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import RecommendedFeaturedContent from '@bibliocommons/recommended-featured-content';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import FeatureContentActions from '../actions/FeaturedContentActions';

function mapStateToProps(state) {
  const catalogSearch = state.getIn(['search', 'catalogSearch']);
  const library = currentLibrarySelector(state);
  return {
    featuredContent: catalogSearch.get('featuredContent',
      Immutable.Map()).reduce((transformedFeaturedContent, contentIds, contentType) =>
        transformedFeaturedContent.set(
          contentType,
          contentIds.map(id => state.getIn(['entities', 'featuredContent', id.toString()]))
        ),
      Immutable.Map()),
    results: catalogSearch.get('results').flatten(),
    libraryShortName: library.get('shortName')
  };
}

class FeaturedContentContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    this.featuredContentActions = bindActionCreators(FeatureContentActions, this.props.dispatch);
  }

  componentDidMount() {
    if (this.props.results.size > 0) {
      this.featuredContentActions.fetch(this.props.results);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.results.size > 0 && !Immutable.is(this.props.results, nextProps.results)) {
      this.featuredContentActions.fetch(nextProps.results);
    }
  }

  render () {
    return (
      <RecommendedFeaturedContent
        libraryShortName={this.props.libraryShortName}
        content={this.props.featuredContent} />
    );
  }
}

FeaturedContentContainer.propTypes = {
  featuredContent: ImmutablePropTypes.map,
  libraryShortName: PropTypes.string,
  results: ImmutablePropTypes.list
};

export default connect(mapStateToProps)(FeaturedContentContainer);



// WEBPACK FOOTER //
// ./app/containers/FeaturedContentContainer.jsx